import { Injectable } from '@angular/core';
import { IApplicationDirector } from '../director';
import { ISandbox } from './sandbox.interface';

abstract class BaseSandbox {
  get channels(): any { return { }; }
  get user(): any { return { }; }

  publish(...args: any[]) {
    return this;
  }
  subscribe(...args: any[]) {
    return this;
  }
  unsubscribe(...args: any[]) {
    return this;
  }
}

@Injectable()
/**
 * @name: Sandbox
 * @intent: Provide an interface for clients to interact with the Core through without touching it directly, protecting encapsulation.
 * @Patterns: { Adapter }
 */
class Sandbox implements ISandbox {
  protected director: IApplicationDirector = null;
  get channels() { return this.director.events; }
  get user() { return this.director.user; }

  constructor() {
    // super();
  }

  publish(...args: any[]) {
    this.director.publish.apply(this.director, args);
    return this;
  }
  subscribe(...args: any[]) {
    this.director.subscribe.apply(this.director, args);
    return this;
  }
  unsubscribe(...args: any[]) {
    this.director.unsubscribe.apply(this.director, args);
    return this;
  }

}

export { Sandbox, BaseSandbox };
